module.exports = __webpack_public_path__ + "static/img/feining.ba5216d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/medicines/feining.jpg
// module id = 383o
// module chunks = 1